$(document).ready(function() {
    // Offset desiderato in pixel (lascia 100px o più sopra l'elemento)
    var offsetTop = 200;

    function smoothScrollToHash(hash) {
        var $target = $(hash);

        if ($target.length) {
            // Controlla la posizione di scroll rispetto al documento
            $('html, body').animate({
                scrollTop: $target.offset().top - offsetTop // Lascia uno spazio di offset
            }, 600); // Scroll fluido in 600ms
        }
    }

    // Blocca lo scroll predefinito al caricamento se c'è un hash
    if (window.location.hash) {
        $('html, body').scrollTop(0); // Resetta lo scroll iniziale
        setTimeout(function() {
            smoothScrollToHash(window.location.hash);
        }, 10); // Esegui lo scroll fluido
    }

    // Gestisci il cambio dell'hash (quando clicchi su un link con hash)
    $(window).on('hashchange', function() {
        smoothScrollToHash(window.location.hash);
    });
});
